<template>
    
</template>
<script>
export default {
  name:"Empty",
  mounted() {
    // 重定向
    this.$router.replace(this.$route.query.router)
  }
}
</script>
